function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function closePopup(cname, cvalue, exdays) {
    jQuery('#std-modal').removeClass('active');
    setCookie(cname, cvalue, exdays);
}


(function($) {

    $(document).on( 'click', '#lang-menu.show', function() {

        $(this).removeClass('show');

    });

})
(jQuery);
